export default "__VITE_ASSET__C9eXB72Y__"